<script>
import { supplierService,productService } from "../../services";
import { required,requiredIf,url } from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message,get_decimal,validate_decimal_input,
  validate_three_decimal_input,
  validate_four_decimal_input } from "../../Helper/helper";
import { decimalNumber,NotZeroNumber } from "../../Helper/formValidation";
import Multiselect from "vue-multiselect";

export default {
  components: { supplierService,Multiselect},
    data() {
        return {
            config: config,
            is_disable: false,
            producer_company : [],
            config: config,
            isDisabled:false,
            isLoading:false,
            products:[],
            error: [],
            supplier_product_chk: [],
            item_vat: "",
            decimal: get_decimal(),
            typeform: {
                producer_company_id:"",
                contact_person:"",
                phone_number:"",
                email:"",
                url:"",
                order_from :"",
                order_until :"",
                delivery_date:"",
                customer_id:"",
                username:"",
                password:"",
                note:"",
                status: 1,
                supplier_subProduct: [{ product:"",tax:"",price_including_tax:"",price_excluding_tax:"" }],
            },
            showPasswordErrors: false,
        };
    },
    validations: {
        typeform: {
            producer_company_id:{
                required,
            },
            // contact_person:{
            //     // required,
            // },
            // phone_number:{
            //     // required,
            // },
            // url:{
            //     // required,
            //     // url
            // },
            // order_from :{
            //     // required,
            // },
            // order_until :{
            //     // required,
            // },
            // delivery_date:{
            //     // required,
            // },
            // customer_id:{
            //     // required,
            // },
            // username:{
            //     // required,
            // },
            // password:{
            //     // required,
            // },
            supplier_subProduct: {
            	$each: {
                	product: {
                    	required: requiredIf(function (form) {
                        	return (
                            	(form.price_including_tax != "" || form.price_including_tax != "")
                        	);
                    	}),
                	},
                	tax: {
                    	required: requiredIf(function (form) {
                        	return (
                            	(form.product != "")
                        	);
                    	}),
                	},
                	price_excluding_tax: {
                    	required: requiredIf(function (form) {
                        	return (
                            	(form.product != "" || form.price_including_tax != "")
                        	);
                    	}),
                	},
                    price_including_tax: {
                    	required: requiredIf(function (form) {
                        	return (
                            	(form.product != "" || form.price_excluding_tax != "")
                        	);
                    	}),
                	},

            	},
        	},
        },
    },
    // computed: {
    //     passwordErrors() {
    //     const password = this.typeform.password;
    //     const errors = [];

    //     if (!password) {
    //         errors.push('Password is required.');
    //     }
    //     if (!/[0-9]/.test(password)) {
    //         errors.push('Password must contain at least one number.');
    //     }
    //     if (!/[A-Z]/.test(password)) {
    //         errors.push('Password must contain at least one uppercase letter.');
    //     }
    //     if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    //         errors.push('Password must contain at least one special character.');
    //     }

    //     return errors;
    //     },
    // },
    mounted() {
        this.getProducerCompany();
        this.asyncFindProduct({search:""});
    },
    methods: {
        decimalNumber,
        NotZeroNumber,
        validatePrivatePrice(value) {
            this.typeform.price = validate_four_decimal_input(value);
        },
        someHandler(event,index) {
            const priceIncludingTax = parseFloat(event.target.value) || 0; 
            const taxRate = parseFloat(this.typeform.supplier_subProduct[index].tax) || 0;

            if (taxRate > 0 && priceIncludingTax > 0) {
                this.item_vat = (priceIncludingTax * taxRate) / 100;
                this.typeform.supplier_subProduct[index].price_including_tax = (
                    priceIncludingTax + this.item_vat
                ).toFixed(this.decimal);
            } else {
                // Handle cases where taxRate or priceIncludingTax is invalid (optional)
                this.typeform.supplier_subProduct[index].price_including_tax = 0;
            }

            console.log(`Price Excluding Tax: ${this.typeform.supplier_subProduct[index].price_including_tax}`);
        },
        checkSupplierProduct(val, i) {
            var id = val.sub_product_id; // Use `sub_product_id` for the selected product
            let chk = this.supplier_product_chk.findIndex((data) => data == id);
            this.error[i] = false;
            if (chk == -1) {
                if (this.supplier_product_chk[i] != "") {
                    this.supplier_product_chk.splice(i, 1, id);
                } else {
                    this.supplier_product_chk.push(id);
                }
            } else {
                this.error[i] = true;
                return false;
            }
            if (this.error[i] == true) {
                return false;
            }

            // Fetch the related sub-product details (like tax) based on the selected product
            this.getSubProduct(val, i);
        },
        // async asyncFindProduct(query) {
        // 	this.isLoading = true;
        //    await supplierService
        //         .getAllProductByNameApi({ query })
        //         .then((response) => {
        //         this.products = response.data.result.sort((a, b) => {
        //             return a.item_name.localeCompare(b.item_name);
        //         });
        //     	this.isLoading = false;
        // 	});
    	// },
        async asyncFindProduct(query) {
            this.isLoading = true;
            try {
                const response = await supplierService.getAllProductByNameApi({ query });
                this.products = response.data.result;
                console.log(this.products);
            } catch (error) {
                console.error('Error fetching products:', error);
            } finally {
                this.isLoading = false;
            }
        },
        getSubProduct(product,index) {
        	var sub_product_id = product.sub_product_id;
        	// this.subProducts = [];
        	// this.typeform.tax = "";
            this.typeform.supplier_subProduct[index].tax = [];
        	this.isLoading = true;
        	supplierService
            	.getSubProductApi({ sub_product_id:sub_product_id})
            	.then((response) => {
                this.typeform.supplier_subProduct[index].tax = response.data.result.vat;
        	});
    	},
        floatingNumber(e) {
            const floating = /^[0-9.]\d*(\.\d{0,2})?$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        addSupplier(){
            // console.log(this.$v.typeform.$touch());
            this.$v.typeform.$touch();
            // console.log($(".is-invalid:first").offset().top-$('#page-topbar').height()-50)
            if (this.$v.typeform.$invalid) {
                return;
            } else {

                const transformedB2BCustomers = this.typeform.supplier_subProduct
                .filter(customer => !(customer.product === "" && customer.tax === "" && customer.price_including_tax === "" && customer.price_excluding_tax === ""))
                .map(customer => {
                    return {
                        product: customer.product.sub_product_id,
                        tax: customer.tax,
                        price_including_tax: customer.price_including_tax,
                        price_excluding_tax: customer.price_excluding_tax
                    };
                });

                // Prepare the form data with transformed supplier_subProduct
                const formData = {
                    ...this.typeform,
                    supplier_subProduct: transformedB2BCustomers,
                    // producer_company_id: this.producer_company[0].id,
                   
                };


                this.is_disable = true;
                supplierService.addSupplier(formData).then((response) => {
                    if (response.data.code === 200) {
                        success_message(response.data.message);
                        this.$router.push({ name: "supplier-list" });
                    } else {
                        error_message(response.data.message);
                    }
                    this.is_disable = false;
                });
            }
        },
        getProducerCompany(page) {
            this.loading = true;
            supplierService
            .getProducerCompany()
            .then((response) => {
                this.loading = false;
                // this.producer_company = response.data.result.data;
                // console.log(this.producer_company);
                this.producer_company = response.data.result;
                // const producerNames = producers.map(producer => producer.producer_name);

                // // Sort the names in ascending order
                // this.producer_company=  producerNames.sort((a, b) => a.localeCompare(b));

                // // Log the sorted names

                // // Optionally store the sorted names in a component property
                // this.sortedProducerNames = producerNames;
            });
        },
        AddField() {
        	this.typeform.supplier_subProduct.push({ product:"",tax:"",price_including_tax:"",price_excluding_tax:""});
    	},
    	remove_field(i) {
        	this.typeform.supplier_subProduct.splice(i, 1);
    	},
        restrictToNumbers(event) {
            // Replace any non-numeric characters with an empty string
            event.target.value = event.target.value.replace(/[^0-9]/g, '');
            this.typeform.phone_number = event.target.value;
        },  
        restrictToTaxNumbers(event,index) {
            const value = event.target.value;
                const formattedValue = value.replace(/[^0-9.]/g, ''); // Allow only numbers and decimal points

                // Ensure only one decimal point is allowed
                const parts = formattedValue.split('.');
                if (parts.length > 2) {
                    return; // Prevent further input if there are more than one decimal point
                }

                // Update the input and model
                event.target.value = formattedValue;
                this.$set(this.typeform.supplier_subProduct[index], 'price_excluding_tax', formattedValue);
        },
    },
};

</script>
<template>
    <form @submit.prevent="addSupplier">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Supplier Information') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">

                    <!-- <div class="col-sm-4">
                        <div class="form-group">
                        <label class="required">{{ trans.trans("__JSON__.Supplier Name") }}</label>
                            <multiselect
                            v-model="$v.typeform.producer_company_id.$model"
                            label="producer_name"
                            track-by="id"
                            :placeholder="
                            trans.get('__JSON__.Select Supplier name')
                            "
                            open-direction="bottom"
                            :options="producer_company"
                            :multiple="false"
                            :searchable="true"
                            :internal-search="true"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :max-height="600"
                            :show-no-results="true"
                            :hide-selected="true"
                            @select="getProducerCompany($event)"
                            name="producer_company_id"
                            :class="{
                            'is-invalid':
                                $v.typeform.producer_company_id.$error,
                            }"
                        >
                            <span slot="noResult"
                            >{{
                                trans.get(
                                "__JSON__.Oops! No elements found. Consider changing the search query"
                                )
                            }}.</span
                            >
                        </multiselect>
                        <div v-if="$v.typeform.producer_company_id.$error" class="form-error">
                            <span v-if="!$v.typeform.producer_company_id.required">{{
                            trans.get("__JSON__.Please Select Supplier name")
                            }}</span>
                        </div>
                        </div>
                    </div> -->

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Supplier Name')}}</label>
                            <select class="custom-select" v-model="$v.typeform.producer_company_id.$model" id="producer_company_id" name="producer_company_id" :class="{ 'is-invalid': $v.typeform.producer_company_id.$error }"> 
                                <option disabled value="">{{ trans.get('__JSON__.Please Select Supplier name') }}</option>
                                <option v-for="pcom in producer_company" :value="pcom.id" :key="pcom.id">{{pcom.producer_name}}</option>
                            </select>
                            <div v-if="$v.typeform.producer_company_id.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.producer_company_id.required">{{ trans.get('__JSON__.Please Select Supplier name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Contact Person')}}</label>
                            <input
                                id="contact_person"
                                v-model="typeform.contact_person"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Contact Person')"
                                name="contact_person"
                            />
                            <!-- <div v-if="$v.typeform.contact_person.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.contact_person.required">{{ trans.get('__JSON__.Please enter contact person name') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Phone Number')}}</label>
                            <input
                                maxlength="15"
                                minlength="12"
                                id="phone_number"
                                v-model="typeform.phone_number"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Phone Number')"
                                name="phone_number"
                                @input="restrictToNumbers"
                            />
                            <!-- <div v-if="$v.typeform.phone_number.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.phone_number.required">{{ trans.get('__JSON__.Please enter phone number') }}</span>
                                <span v-if="!$v.typeform.phone_number.numeric">{{ trans.get('__JSON__.Phone number must be numeric') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Email')}}</label>
                            <input
                                id="email"
                                v-model="typeform.email"
                                type="email"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Email')"
                                name="email"
                            />
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.URL')}}</label>
                            <input
                                id="url"
                                v-model="typeform.url"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.URL')"
                                name="url"
                                
                            />
                            <!-- <div v-if="$v.typeform.url.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.url.required">{{ trans.get('__JSON__.Please enter Url') }}</span>
                                <span v-if="!$v.typeform.url.url">{{ trans.get('__JSON__.Please enter a valid URL') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Order From')}}</label>
                            <input
                                id="order_from "
                                v-model="typeform.order_from"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Order Form')"
                                name="order_from "
                            />
                            <!-- <div v-if="$v.typeform.order_from .$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.order_from .required">{{ trans.get('__JSON__.Please enter Order Form') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Order Unitl')}}</label>
                            <input
                                id="order_until "
                                v-model="typeform.order_until"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Order Unitl')"
                                name="order_until "
                               
                            />
                            <!-- <div v-if="$v.typeform.order_until .$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.order_until .required">{{ trans.get('__JSON__.Please enter Order Until') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Delivery Date')}}</label>
                            <input
                                id="delivery_date"
                                v-model="typeform.delivery_date"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Delivery Date')"
                                name="delivery_date"
                                
                            />
                            <!-- <div v-if="$v.typeform.delivery_date.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.delivery_date.required">{{ trans.get('__JSON__.Please enter delivery date') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Customer Id')}}</label>
                            <input
                                id="customer_id"
                                v-model="typeform.customer_id"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Customer Id')"
                                name="customer_id"
                               
                                maxlength="20"
                            />
                            <!-- <div v-if="$v.typeform.customer_id.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.customer_id.required">{{ trans.get('__JSON__.Please enter Customer Id') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.User Name')}}</label>
                            <input
                                id="username"
                                v-model="typeform.username"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.UserName')"
                                name="username"
                                
                            />
                            <!-- <div v-if="$v.typeform.username.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.username.required">{{ trans.get('__JSON__.Please enter user name') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Password')}}</label>
                            <input
                                id="password"
                                v-model="typeform.password"
                                type="password"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Password')"
                                name="password"
                                @input="showPasswordErrors = true"
                               
                            />
                            <!--  :class="{ 'is-invalid': showPasswordErrors && passwordErrors.length > 0 || $v.typeform.password.$error}"<div v-if="showPasswordErrors && passwordErrors.length > 0 || $v.typeform.password.$error" class="invalid-feedback">
                                <div v-for="(error, index) in passwordErrors" :key="index">
                                    <span>{{ error }}</span>
                                </div>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Note')}}</label>
                            <textarea
                                id="note"
                                v-model="typeform.note"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Note')"
                                name="note"
                            ></textarea>
                        </div>
                    </div>

                    <div class="col-sm-6 vendor-status">
                        <b-form-group
                            id="input-group-1"
                            :label="trans.get('__JSON__.Status')"
                            label-for="status"
                            >
                            <label class="switch">
                                <input
                                type="checkbox"
                                id="togBtn"
                                name="status"
                                v-model="typeform.status"
                                class="switch-on"
                                true-value="1"
                                false-value="0"
                                />
                                <div class="slider round">
                                <span class="on">{{ trans.get("__JSON__.Active") }}</span>
                                <span class="off">{{ trans.get("__JSON__.Inactive") }}</span>
                                </div>
                            </label>
                        </b-form-group>
                    </div>
                </div>
                
            </div>
        </div>

        <div class="card">
        	<div class="card-body">
          	<h4 class="card-title">
            	{{ trans.get("__JSON__.Products") }}
          	</h4>
            	<div class="row" v-for="(v, i) in $v.typeform.supplier_subProduct.$each.$iter" :key="i">
                	<div class="col-sm-4">
                    	<div class="form-group">
                            <label>{{ trans.trans("__JSON__.Product") }}</label>
                            <multiselect
                                v-model="v.product.$model"
                                id="product"
                                label="item_name"
                                track-by="sub_product_id"
                                :placeholder="trans.get('__JSON__.Type to Search Product')"
                                open-direction="bottom"
                                :options="products"
                                :multiple="false"
                                :searchable="true"
                                :internal-search="true"
                                :close-on-select="true"
                                :clear-on-select="true"
                                :max-height="600"
                                :show-no-results="true"
                                :hide-selected="true"
                                product="products[]"
                                @select="checkSupplierProduct($event, i)"
                                :class="{
                                'is-invalid': v.product.$error || error[i],
                                }"
                                >
                                <span
                                slot="noResult"
                                >{{ trans.get('__JSON__.Oops! No elements found. Consider changing the search query') }}.</span>
                            </multiselect>
                            <div v-if="v.product.$error || error[i]" class="form-error">
                                <span v-if="!v.product.required">{{ trans.get("__JSON__.Please select product") }}</span>
                                <span v-if="error[i]">{{ trans.get("__JSON__.This product has already been added. Please select another product") }}</span> <!-- Custom error message -->
                            </div>
                    	</div>
                	</div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label>{{ trans.trans("__JSON__.Tax") }}</label>
                            <input
                            v-model="v.tax.$model"
                            type="text"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.Tax')"
                            name="tax[]"
                            disabled="disabled"
                            :class="{
                                'is-invalid': v.tax.$error,
                            }"
                            />
                            <div v-if="v.tax.$error" class="invalid-feedback">
                                <span v-if="!v.tax.required">{{
                                    trans.get("__JSON__.Please add tax")
                                }}</span>
                            </div>
                        </div>
                        
                	</div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label>{{
                                trans.trans("__JSON__.Purchase Price (Excluding Vat)")
                            }}</label>
                            <input
                                id="price"
                                v-model="v.price_excluding_tax.$model"
                                type="text"
                                class="form-control"
                                :placeholder="
                                trans.trans('__JSON__.Purchase Price (Excluding Vat)')
                                "
                                name="price_excluding_tax"
                                :class="{ 'is-invalid': v.price_excluding_tax.$error }"
                                @input="restrictToTaxNumbers($event,i)"
                                @paste="restrictToTaxNumbers($event, i)"
                                autocomplete="off"
                                autocorrect="off"  
                                autocapitalize="off" 
                                spellcheck="false"  
                                v-on:keyup="someHandler($event,i)"
                            />
                            <div v-if="v.price_excluding_tax.$error" class="invalid-feedback">
                                <span v-if="!v.price_excluding_tax.required">{{
                                trans.get("__JSON__.Please enter purchase price")
                                }}</span>
                                 <span v-if="v.price_excluding_tax.$error && !/^(-?\d+(\.\d+)?)$/.test(v.price_excluding_tax.$model)">
                                    {{ trans.get("Only numeric and decimal values are allowed.") }}
                                </span>
                            </div>
                        </div>
                	</div>
                    <div class="col-sm-2">
                        <div class="form-group">
                        <label>{{
                            trans.trans("__JSON__.Purchase Price (Including Tax)")
                        }}</label>
                        <input
                            maxlength="5"
                            minlength="1"
                            id="price_including_tax"
                            v-model="v.price_including_tax.$model"
                            type="text"
                            class="form-control"
                            :placeholder="trans.trans('__JSON__.Purchase Price (Including Tax)')"
                            name="price_including_tax"
                            :class="{ 'is-invalid': v.price_including_tax.$error }"
                            :readonly="true"

                        />
                        <div
                            v-if="v.price_including_tax.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!v.price_including_tax.required">{{
                            trans.get("__JSON__.Please enter purchase price")
                            }}</span>
                        </div>
                        </div>
                    </div>
                	
                	
                	<div class="col-md-2">
                	<h6>&nbsp;</h6>
                	<button
                    	class="btn btn-primary btn-sm btn-rounded"
                    	@click.prevent="AddField()"
                	>
                    	+</button
                	>&nbsp;&nbsp;
                	<button
                    	class="btn btn-danger btn-sm btn-rounded"
                    	v-if="i != 0"
                    	@click.prevent="remove_field(i)"
                	>
                    	-
                	</button>
                	</div>
            	</div>
            	<div class="row">
                    <div class="col-sm-4">
                        <button class="btn btn-primary mr-1 mt-3" :disabled="is_disable">{{ trans.get('__JSON__.Add Supplier') }}</button>
                        <router-link
                            :to="{name:'supplier-list'}"
                        >
                            <b-button 
                                type="button" 
                                variant="secondary" 
                                class="mt-3">   
                                {{ trans.get('__JSON__.Cancel') }}
                            </b-button>
                        </router-link>    
                    </div>
                </div>
        	</div>
      	</div>
    </form>
</template>